import Axios from 'axios'
import store from '../../store/index'

//
//Should be called when there is a token and need to access to authorized resource
//
function authenticatedAxios() {
    //Always get token from store after logged in
    return Axios.create({
        headers: {
            'Authorization': `Bearer ${store.state.auth.auth.token}`
        }
    });     
}
//
//Get data from server by GET method without authorization and parameters
//
async function getData(url) {
    await Axios.get(url)
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    if (error.response) {

                    }
                    else if (error.request) {

                    }
                    else {

                    }
                });
}

//
//Get data from server by GET method with authorization token
//
async function getDataWithToken(url) {
    let response;
    
    await authenticatedAxios().get(url)
                              .then((res) => {
                                    response = res.data;
                              })
                              .catch((error) => {
                                  if (error.response) {
                                      store.commit('auth/SET_LOGOUT_STATE');
                                      //authStorage.clearAuth();

                                  }
                                  else if (error.request) {

                                  }
                                  else {

                                  }
                              })
    return response;           
}

//
//Post data to server by POST method with authorization token
//
async function postData(url, data) {
    return await authenticatedAxios().post(url, data);
} 

//
//Put data to server by PUT method with authorization token
//
async function putData(url, data) {
    return await authenticatedAxios().put(url, data);
} 

//
//Delete data to server by DELETE method with authorization token
//
async function deleteData(url) {
    return await authenticatedAxios().delete(url);
}

async function postFile(url, formData) {
    return await Axios.create({
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${store.state.auth.auth.token}`
        }
    }).post(url, formData);
   
}

export default {
    name: 'common',
    getData,
    getDataWithToken,
    postData,
    putData,
    deleteData,
    postFile
}